import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FocusFirstInputDirective } from './focus-first-input.directive';

@NgModule({
  declarations: [
    FocusFirstInputDirective,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    FocusFirstInputDirective,
  ],
})
export class FocusFirstInputModule {
}
